<template>
  <div>
    <div class="position-abs align-central text-center">
      <img alt="" class="width-200" :src="logoTransparent" />
      <h2>Welcome to <b>PANDA</b> Loan System</h2>
    </div>
    <div
      style="position: fixed; right: 0; bottom: 50px; margin: auto 0; padding: 10px;"
    >
    </div>
  </div>
</template>

<script>
import logoTransparent from '@/assets/images/logo-transparent.png'

export default {
  data () {
    return {
      logoTransparent: logoTransparent
    }
  },
  mounted () {
  }
}
</script>
